<template>
  <div>
    <div id="resume" class=" wrapper-90p" style="padding-bottom:;" >	
        <!-- brief -->
        
        <h4 class="pri-text " style="padding-left:16px;">About me</h4>
        <div class="row">
          <ul class="resume_content col m6" data-scroll="">
            <h6>Brief</h6>
            <li>
              7年UI/UX工作經驗，專精於Web Design與策略性思考
              <!-- <a>5 years</a> experience in <a>UI/UX design</a>, especially proficient in <a>RWD</a>. -->
            </li>
            <li>
              其中3年兼任PM，熟知<a>產品管理、驗收、敏捷式方法</a>
              <!-- I also served as a <a>PM</a> for <a>3 years</a>, familiar with the method of <a>product management</a> & <a>Agile/SCRUM</a>. -->
            </li>
            <li>
              <!-- I'm good at <a>analysis complex user scenario</a> like multi-role, multi-permission, or admin functions. So that I can generate highly flexiable and achievable UI. -->
              擅長整理、分析複雜的使用情境 ( 多角色、多權限、前後台 ) ，設計高彈性且可實踐的介面。
            </li>
            <li>
              <!-- I've design several RWD websit from scratch, include e-Learning and big data system.  -->
              進行過多個<a>大型後台網站的RWD</a>，含大量表單、圖表頁面，須確保控制元件於行動裝置良好操作
            </li>
            <li>
              <!-- Have experience in E-commer APP design like <a>shopping cart system</a> or <a>sign/up function</a>. -->
              電商網站設計經驗 (<a> 購物車系統</a>、<a>登入與註冊流程</a> )
            </li>
            <li>
              <!-- Self-learning for knowledge than can help me cooperate with team better, EX: Agile, Sketch APP, Prototyping Tools. -->
              可配合團隊分工模式調整自己的工作流，自我精進所需知識( 如Agile, Sketch, Prototyping Tools )
            </li>
          </ul>
          <ul class="resume_content col m6" data-scroll="" >
            <h6>Goal</h6>
            <li>
              <!-- Become UX leader or product manage in a team, so that I can lead team members apply good UX method to achieve excellent product design.  -->
              成為UX Lead或Product Manager, 協同團隊完成卓越的產品設計
            </li>
            <li>
              <!-- Design something that really can help people in daily life or job, for example, productive tool. -->
              設計對人們的日常生活與工作有幫助的產品，例如生產力工具
            </li>
            <li>
              <!-- Continously learn and practice scientic desgin method, incloud both quantitive and qualitive research. -->
              持續學習並實踐科學化的設計方式，包含質化與量化的研究
            </li>
            <!-- <li>
              以雙北地區工作為目標
            </li> -->
          </ul>
        </div>
    </div>
    <div class="wrapper-90p" style="padding-bottom:20px;padding-top:20px;background:rgba(131, 195, 255, 0.39);">
      
        <!-- <div class="clearfix p-divider"></div> -->
        <h4 class="pri-text" style="padding-left:16px;">Skills</h4>
        <div class="row">
          <ul class="resume_content col m3 s12" data-scroll="" >
            <h6>Product Management</h6>
            <li>
               Product Owner in SCRUM
            </li>
            <li>
              Road Map Planning
            </li>
            <li>
              Familiar with Kanban Tool
            </li>
            <li>
              Good at negotiating with developers
            </li>
                  
          </ul>
          <ul class="resume_content col m3 s12" data-scroll="" >
            <h6>UX Design</h6>
            <li>
              User Research
            </li>
            <li>
               <span class="">Wireframe</span>
            </li>
            <li>
              <span class="">Usability Test</span>
            </li>
            <li>
              GA & hotjar Tracking
            </li>
            <li>
              LeanUX
            </li>
          </ul>
          
          <ul class="resume_content col m3 s12"  data-scroll="">
            <h6>UI Design</h6>
            
            <li>
              <span class="">UI Spec</span>
            </li>
            <li>
              <span class="">Design System</span>
            </li>
            <li>
              Prototyping
            </li>
            <li>
              <span class="">Graphic Design</span>
            </li>

                  
          </ul>
          <ul class="resume_content col m3 s12"  data-scroll="">
            <h6>Front-End</h6>
            <li>
              HTML5/CSS/JS
            </li>
            <li>
              RWD
            </li>
            <li>
              Vue.js
            </li>
            <li>
              HighChart.js
            </li>
            <li>
              Google Tag Manager
            </li>
                  
          </ul>
        </div>
    </div>
    <div class="wrapper-90p" style="padding-top:60px;">
        
        <!-- <div class="clearfix" style="padding: 0 10%;height:100px;"></div> -->
        <!-- Experience -->
        <div class="row">
          <div class="col m6 resume_content" style="margin-top:0px;position:relative;" data-scroll="">
            <h4 class="pri-text">Experience</h4>
            <ul class="">
              <span>
                2017/08 ~ Ongoing
              </span>
              <h6>OneAD果實夥伴 - Senior UI/UX Designer</h6>
              <span class="company_intro">
                OneAD為台灣本地影音廣告服務領導者，<br>廣告版位遍布各大主流媒體平台，並有專門的數據團隊研究廣告Big Data應用。<br>
                我的貢獻：
                <!-- <br>
                OneAD is the local leader of video format advertisement in Taiwan, <br>
                which has advertisement boards around all main medias in Taiwan and has a specialized data-science-team for big data applications. <br>
                
                My contributions: -->
              </span>
              <li>
                <a>從零到有的設計多種Big Data分析工具</a>，如：廣告受眾管理系統、廣告成效轉換率漏斗報表、廣告成效試算與比較功能
                <!-- Design several advertisement big data analysis tools from scratch, for example, audience manager, conversion rate funnel report, and advertisement planning calculator. -->
              </li>
              <li>
                優化OneAD龐大的<a>廣告投放與報表系統</a>，透過多次迭代與定期的使用者訪談改善其使用體驗
                <!-- Optimize UX of the huge and complex advertise manipulating platform by doing many iterations and periodical user interviews. -->
              </li>					
              <li>
                在OneAD<a>建立UI/UX設計體系</a>、改善既有的純工程師開發流程，<br>
                為團隊帶入Wireframe與Prototype文化。
                <!-- <br>
                Bring UI/UX desgin process such like wireframe and prototyping concept into OneAD. -->
              </li>					
              <li>
                建立<a>Design System</a>，令公司新舊系統能有一致性、易優化的UI。
                <!-- <br>
                Establish a design system to make sure the consistency and usability for new and former products.  -->
              </li>
              <li>
                依目標議題實施適合的UX方法如：User Story Mapping, Card Sorting, GA, Heatmap等 
                <!-- Apply UX research method depend on design issue. For example, User Story Mapping, Card Sorting, GA, Heatmap. -->
              </li>
            </ul>
            <ul class="">
              <span>
                2016/06 ~ 2017/05
              </span>
              <h6>17life – 資深UI設計師&#160;
                <!-- <a href="img/Resume/exp-2.jpg" data-fancybox="exp" style="display:inline-flex;font-size:16px;">[ View Detail → ]</a> -->
              </h6>
              <span class="company_intro">
                17Life為台灣主流團購電商之一，以B2B2C的型式提供服務。<br>
                我的貢獻：
                <!-- 17Life is one of group buying e-commerce website in Taiwan, provide B2B2C service to both merchant and consumer. -->

                
                <!-- My contributions: -->
              </span> 
              <li>
                <!-- Design UI of new functions for 17Life ecommerce RWD website and mobile site. -->
                負責PC版(RWD)與Mobile版網站的UI設計與切版，並累積大量的html/css/js經驗
              </li>
              <li>
                設計<a>B2B2C型的購物車系統</a>，兼容<a>跨倉儲免運費</a>等複雜結構
                <!-- Designed B2B2C shoppoing cart system. -->
              </li>
              <li>
                設計<a>RWD版登入/註冊畫面</a>
                <!-- Resigned log-in and sign up UI. -->
              </li>
              <li>
                <!-- Deisgn a new merchandise management system. -->
                設計<a>商品上架系統</a>，供店家自行操作、管理商品
              </li>
            </ul>
            <ul class="">
              <span>
                2013/04 ~ 2016/05
              </span>
              <h6>一宇數位 – 產品企畫專員&#160;
                <!-- Learning Digital -->
                <!-- <a href="img/Resume/exp-1.jpg" data-fancybox="exp" style="display:inline-flex;font-size:16px;">[  View Detail → ]</a> -->
              </h6>
              <span class="company_intro">
                一宇數位為台灣主要的HRD系統開發商之一，為台灣的大型企業建立教育訓練與人才管理系統，包含e化培訓、KPI、MBO、員工發展藍圖、人材庫等應用。
                <br>我的貢獻：
                <!-- LearningDigital is one of the main seller of HRD system in Taiwan. It provides human capital management functions such like e-Learning, KPI, MBO, blue-print,and talent-pool.
                
                My contributions: -->
              </span> 
              <li>
                需求分析、產品企畫、APP/Web UI設計、製作網頁原型
                <!-- <br />
                Requirement analytics, product planning, APP/Web UI Design, F2E(html/css/js). -->
              </li>
              <li>
                <!-- Improved the UI/UX of the existing product - Orca Mobile, an online learning platform, 
                and I designed new functions for it such like video course offline-learning, quiz functions on mobile, and B2B2C consuming system. -->
                優化既有產品 - OrcaMobile學習平台的UI/UX，並因應商業需求企畫新功能，如<a>手機課程離線閱讀, 行動考試中心, B2B2C的學習點數消費機制</a>
              </li>
              <li>
                <!-- Improved the UI/UX of the existing product - Orca HC, the main HRD product of LearningDigital which building in enterprise intranet, 
                and I redesgin the whole system UI into RWD version. -->
                優化既有產品 - Orca HCM的UI/UX，統計數十個頁面的使用情況，進行Redesign與RWD化再通過Usability Test檢驗，進而整理成Design System以加速開發
              </li>
              <li>
                <!-- Helped CTO apply SCRUM and I was PO for two years long.	 -->
                協助CTO<a>導入SCRUM，擔任PO</a>並主動學習、嘗試讓流程順暢，適時和CTO或SCRUM成員討論如何改善運作機制
              </li>
              <li>
                每兩週1小時對團隊進行UI/UX相關技術分享
              </li>
            </ul>
          </div>
      
          <!-- education -->
          <div class="col m6 resume_content" style="margin-top:0px;position:relative;" data-scroll="">
            <h4 class="pri-text">Education</h4>
            
            <ul class="">
              <span>
                2010/09～2012/06
              </span>
              <h6>大同大學 - 工業設計研究所碩士 </h6>
              <span>
                領略形隨機能與設計減法的理念，傾向為服務使用者出發來做創意，因此學習並實踐UX設計驗證
              </span>
            </ul>
            <ul class="">
              <span>
                2004/09～2008/06
              </span>
              <h6>國立交通大學 - 電信工程學系學士</h6>
              <span>
                對比本科與營隊社團經驗，發覺自己對發想點子和動手做創新的喜愛
              </span>
            </ul>
          </div>
      
          <!-- biography -->
          <div class="col m6 resume_content"  data-scroll="">
            <h4 class="pri-text">Biography</h4>
            <ul class="" >
              <p>
                我出生於高雄,現居於新北市板橋，是一個跨領域背景的UI/UX設計師。
                <br />
                大學就讀國立交大電信系；研究所則為大同工業設計所。
              </p>
              <p>
                大學期間，我常參加系學會和社團的營隊活動，其中常常需要"想點子"並帶給人們驚喜，此類工作令讓我樂在其中；同時我也一直對機械科幻事物十分喜愛。
                <br />
                相反的，我在抽象的電機理工科目中則找不到具體的追求目標。
                
                因此，我在研究所轉讀工業設計，追求理解造型魅力、如何善用創意的道路。
              </p>
              <p>
                在工設研究所時，我多方涉略各種設計項目，逐漸形成自己的設計理念 - -
                <br />
                形隨機能、少即是多，透過對需求的推導將創意的亮點集中在使用者在乎的地方上，藉此來成就自豪的產品設計。

              </p>
              <p>
                我相信從常見的Web/Tablet/Phone，到AR、VR，乃至穿戴式裝置，當越來越多新型態的服務載體出現時，可依循的前例會來越少。
                定義一個好產品的共通點，將需要從Design Thinking的角度出發，去觀察、假設與驗證。
                而我也相信，對UX的投入經驗將可能在未來使我有能力為任何陌生的新產品塑造最好的體驗。
              </p>
              <p>
                畢業後，我進入了一宇數位  -  一家從企業人才經營(HCM)出發，開發B2B線上學習平台的公司。
                做平台的產品是很特別的經驗，與接專案的公司不同，我常需在開發新功能之餘，不定期的收集各各獨立功能模組的使用者痛點、與有助進攻客戶的新需求。
                也因此常需多線思考，並且時時以全平台使用經驗的一致性與延續性為出發點做設計。
              </p>
              <p>
                公司採敏捷式開發(SCRUM)的步調開發產品，我亦深度體會到此型快速迭代的開發方法的利與弊，特別是如何在快速的開發步調中顧好使用者經驗上的品質，是我一直用心拿捏的方向。

              </p>
              <p>
                而後我在17life電商擔任一年時間的UI設計師，專注於提升自己在UI和網頁撰寫技術的能力。
              </p>

              <p>
                如今希望能夠透過我在UI實踐的能力及做產品經理時對大局與複雜情境的掌握能力，為吸引我的產品推動更美好的使用經驗。
              </p>

            </ul>
            
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import Nav from '../components/Navbar_index'
import ScrollOut from 'scroll-out'
export default {
  name: 'home',
  components: {
    // Nav
  },
  mounted() {
    this.so = ScrollOut({
      scope: this.$el,
      threshhold: 0.5, 
      cssProps: { 
          visibleY: true 
      } 
      // cssProps:true,
    });
  },
  destroyed() {
    this.so.teardown();
  },
}
</script>